var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.41421L0 14.5858C0 15.4767 1.07714 15.9229 1.7071 15.2929L8.29289 8.70711C8.68342 8.31658 8.68342 7.68342 8.29289 7.29289L1.70711 0.707108C1.07714 0.0771427 0 0.523308 0 1.41421Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPrimary);
export default __webpack_public_path__ + "static/media/RightArrowPrimary.6e48ad643d98fb8ca5c11b01e7b7249a.svg";
export { ForwardRef as ReactComponent };